//@flow
import InvertedViewModel from "./InvertedViewModel";
export { InvertedViewModel };